import http from '../../Common/api';
import { payerDomain } from '../../Common/constants';

import { aggregatorsUrl, payersUrl, dropDownDefault } from './constants';
import { normalizeAggregators, normalizePayers, normalizeProcedures } from './normalizers';

const getAggregatorOptions = async () => {
  try {
    const aggregators = await http.get(aggregatorsUrl);

    return normalizeAggregators(aggregators);
  } catch (error) {
    return dropDownDefault;
  }
};

const getPayerOptions = async aggregatorID => {
  try {
    const payers = await http.get(`${payersUrl}${aggregatorID}/`);

    return normalizePayers(payers);
  } catch (error) {
    return [];
  }
};

const getProcedureReports = async ({ aggregatorID, payerID }) => {
  try {
    const state = aggregatorID.slice(0, 2);
    const proceduresUrl = `${payerDomain}/procedure-codes-for-payer/${state}/${payerID}/`;
    const response = await http.get(proceduresUrl);

    return normalizeProcedures(response.procedureCodes);
  } catch (error) {
    return [];
  }
};

export { getAggregatorOptions, getPayerOptions, getProcedureReports };
